export default __webpack_public_path__ + "static/about_biodiesel-c25b3d061eed1ea90e16b070e70cade9.webp";